<script>
    import Div from './Div.svelte';
    import Fix from './Fix.svelte';    
    import { lge } from './store.js';
    import { onMount } from 'svelte';
    let hdrs = ['','First','Second','Third','Fourth','Fifth','Sixth']
    let data = [[],[]];
    let lgehdr = '';
    let ndx  = [0,1]; 
    let hdofs;

    async function getData() {
         switch($lge) {
         case 1:
            lgehdr = 'Leicester & Dist. Bowls League';
            hdofs = 0;
            break;
         case 3:
         case 5:
            lgehdr = 'South Leicester Triples League';
            hdofs = 2;
            break;
         case 7:
         case 9:
         case 11:               
            lgehdr = 'Hinckley & Dist. Triples League';
            hdofs = 6;
            break;
         }
         const res = await fetch(`https://www.bowls-league.com/ldbl/files/league${$lge}.json`);
         data[0] = await res.json();
         const res1 = await fetch(`https://www.bowls-league.com/ldbl/files/league${$lge+1}.json`);
         data[1] = await res1.json();
	     }

    onMount (() => {getData()});
</script>

<style>
.container {
    display:grid;
    grid-template-columns:40% 7.5% 7.5% 7.5% 12.5% 12.5% 12.5%;
    grid-row-gap: 4px;
    }

.hdr {
    background:tan
}

.item {
    border:1px solid rgba(0, 0, 0, 0.8);
    padding:2px;
    text-align:left
}

.itm {
    border:1px solid #000000cc;
    padding:2px;
    text-align:right
}

h2,h3 {
    text-align: center;
    margin: 0 0 0 0;
    padding: 2px;
    background-color: mistyrose
}

.higher {
  line-height: 1.5;
}
</style>
<section >
  <h2 class="higher">{lgehdr}</h2>
  {#each ndx as dvn}
    <h3>{hdrs[$lge + dvn - hdofs]} Division</h3>
    <div class="container">
       <div class="item hdr">&nbsp;Teams</div><div class="itm hdr">P&nbsp;</div>
       <div class="itm hdr">W&nbsp;</div><div class="itm hdr">D&nbsp;</div>
       <div class="itm hdr">Pts&nbsp;&nbsp;</div>
       <div class="itm hdr">Shts&nbsp;</div><div class="itm hdr">Agns&nbsp;</div>
       {#each data[dvn] as team }
          <div class="item"><a href="#/fix/{team.i}">{team.n}</a></div>
          {#each team.d as num}
            <div class="itm {team.v < team.d[0] ? 'nvd' : ''}">{num}</div>
          {/each}
       {/each}
    </div>
   {/each}
</section>
<footer>
     <Div on:LgeUpd={getData}/>
</footer>